import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  inject,
  effect,
  output,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ButtonComponent, IconComponent } from 'src/app/ui-kit';
import { NgClass } from '@angular/common';
import { NavigationState } from 'src/app/store/navigation/navigation.state';
import { DeviceState } from 'src/app/store/device/device.state';
import { BottomNavItem, Color, MenuButtonConfig } from 'src/app/shared/types';

@Component({
  selector: 'app-global-nav-bar',
  templateUrl: './global-nav-bar.component.html',
  styleUrls: ['./global-nav-bar.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    IconComponent,
    RouterLink,
    RouterLinkActive,
    NgClass,
  ],
  host: {
    class: 'display: contents',
  },
})
export class GlobalNavBarComponent implements OnDestroy {
  // --- Injected dependencies ---
  private readonly nav = inject(NavigationState);
  private readonly deviceState = inject(DeviceState);
  private readonly cdr = inject(ChangeDetectorRef);

  readonly menuButtonClicked = output<void>();
  visible: boolean | null = null;
  menuButton: MenuButtonConfig = { visible: false, icon: 'menu' };
  color!: Color;
  transparent: boolean = false;
  content: BottomNavItem[] = [];
  minWidth: string = '0rem';

  constructor() {
    // React to bottom nav bar state changes
    effect(() => {
      const bottomNavBar = this.nav.bottomNav();
      this.menuButton = bottomNavBar.menuButton ?? {
        visible: true,
        icon: 'menu',
      };
      this.content = (bottomNavBar.content as BottomNavItem[]) ?? [];
      this.visible = bottomNavBar.visible;
      this.color = bottomNavBar.color ?? 'surface';
      this.transparent = bottomNavBar.transparent ?? false;
      this.calculateMinWidth();
      this.cdr.markForCheck();
    });

    // React to screen width changes for min-width recalculation
    effect(() => {
      // Read the signal to track changes
      this.deviceState.screenWidth();
      this.calculateMinWidth();
      this.cdr.markForCheck();
    });
  }

  calculateMinWidth() {
    const isSmallerThanMediumScreen = this.deviceState.isSmallerThanMediumScreen();
    if (isSmallerThanMediumScreen) {
      // this.minWidth = '100%';
      // return;
    }
    let minWidth = 0;
    if (this.menuButton.visible) {
      minWidth += 5;
    }
    minWidth += (this.content?.length ?? 0) * 5;

    // Add 1rem for each side of the padding
    minWidth += 2;
    this.minWidth = minWidth + 'rem';
  }

  ngOnDestroy() {}
}
